import { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Cookie from 'js-cookie';
// icons
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
//redux
import { useSelector, useDispatch } from 'react-redux';
import { loadMetaCompany } from 'slices/company';
import {
  loginSuccess,
  // setAsociatedLibraryImage,
  fetchUserInfo,
  setIsWorker
} from 'slices/user';
import { cartSelector, addItem } from 'slices/cart';
// api
import { loginApi } from 'api/login';
import { getUserPermissions } from 'api/users';
import { getCart, addItemCart } from 'api/ecommerce';
import { getMetadataCompany, getCategoryMenuNotPaginated } from 'api/company';
//components
import Button from 'components/userzone/buttons/ButtonCustom'
import { InputCustom } from 'components/input';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';


const LoginComp = ({ fromCarro = false }) => {
  const { t } = useTranslation(['login', 'backoffice'])
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { items } = useSelector(cartSelector);
  const userInfo = useSelector(state => state.user);

  const [emailInput, setEmailInput] = useState('');
  const [password, setPassword] = useState('');
  const [invalidCredentials, setInvalidCredentials] = useState(false);
  const [passwordType, setPasswordType] = useState('password');
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const { assignedLibrary } = useAssignedLibrary();


  const onLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      setValidated(true);
      event.stopPropagation();
      return;
    }

    setInvalidCredentials(false);
    setEmailError(false);
    setPasswordError(false);
    if (!emailInput) {
      setEmailError(true);
    }
    if (!password) {
      setPasswordError(true);
    }
    if (!emailInput || !password) {
      return;
    }
    const payload = { username: emailInput, password };
    const { status, data } = await loginApi(payload);
    if (status === 200) {
      localStorage.setItem('access', data.access);
      localStorage.setItem('refresh', data.refresh);
      localStorage.setItem('type_user', data.type_user);
      localStorage.setItem('permissions', data.permissions);
      Cookie.set('access', data.access, { sameSite: 'strict' });
      Cookie.set('refresh', data.refresh, { sameSite: 'strict' });
      Cookie.set('type_user', data.type_user, { sameSite: 'strict' });
      Cookie.set('permissions', data.permissions, { sameSite: 'strict' });
    
      await dispatch(fetchUserInfo());
      await fetchUserInfo();
      await loadUserPermissions();
      navigate('/',{replace: true})
      const metadataCompany = await getMetadataCompany();
      if (metadataCompany.status === 200) {
        const matters = await getCategoryMenuNotPaginated({
          fields: 'id,name,description,genre_ibic'
        });
        if (matters.status === 200) {
          const results = {
            ...metadataCompany.data,
            matters: matters.data
          }
          dispatch(loadMetaCompany(results));
        } else {
          dispatch(loadMetaCompany(metadataCompany.data));
        }
      }
      dispatch(loginSuccess());
      if (data.type_user === 'trabajador') {
        dispatch(setIsWorker(true));
      } else {
        dispatch(setIsWorker(false));
      }
      const cart = await getCart();
      if (cart.status === 200) {
        if (cart.data.items) {
          for (const item of cart.data.items) {
            //No eliminar
            //   console.log('item LOGINCOMP', item);
            //   if (item.producto === null && item.created_gift_card !== null) {
            //     dispatch(setGiftCard(item.created_gift_card));
            //   } else if (item.producto !== null && item.created_gift_card !== null) {
            //     dispatch(addItem(item.producto));
            //     dispatch(setGiftCard(item.created_gift_card));
            //   } else {
            dispatch(addItem(item?.producto));
            // }
          }
        }
      } else {
        console.log('error');
      }

      for (const item of items) {
        await addItemCart({ item: item.id, quantity: item.quantity });
      }

      if (fromCarro) {
        navigate(`/${assignedLibrary}/envio`, { replace: true });
      }
      // fromCarro ? navigate(`/${assignedLibrary}/envio`,{replace: true}) : navigate('/',{replace: true});
    } else if (status === 401) {
      setInvalidCredentials(true);
    } else {
      console.log('Error: ' + data.detail);
    }
    setLoading(false);
  };

  async function loadUserPermissions() {
    try {
      const permissions = await getUserPermissions();
      localStorage.setItem('user_permissions', JSON.stringify(permissions));
    } catch (error) {
      console.error('Error loading user permissions:', error);
    }
  }

  const handleIconType = passwordType === 'password' ?
    <IoEyeOutline className={`position-absolute end-0 translate-middle-y mx-3 cursor-pointer ${password !== '' && 'top-50'}`} onClick={() => setPasswordType('text')} /> :
    <IoEyeOffOutline className={`position-absolute end-0 translate-middle-y mx-3 cursor-pointer ${password !== '' && 'top-50'}`} onClick={() => setPasswordType('password')} />

  return (
    <Form noValidate validated={validated} onSubmit={onLogin} className='login-form col-sm-12 col-md-6 col-lg-5 mx-sm-2'>
      {invalidCredentials && (
        <Col lg={12} className='pt-3'>
          <p className='credentials'>{t('credencialesIncorrectas')}</p>
        </Col>
      )}
      <Row className='container-input pt-4'>
        <div className="col-md-12">
          <p className="mb-0 pb-1 inputTitle openSans">{t('correo')}*</p>
          <InputCustom
            className='login-fields'
            type="text"
            placeholder={`${t('correo')}`}
            onChange={(e) => setEmailInput(e.target.value)}
            value={emailInput}
            required
            error={emailInput === '' && t('camporequerido', { ns: 'backoffice' })}
          />
          {emailError && <span className="text-danger fs-6">{t('camporequerido', { ns: 'backoffice' })}</span>}
        </div>
      </Row>
      <Row className='container-input pt-2'>
        <div className="col-md-12">
          <p className="mb-0 pb-1 inputTitle openSans">{t('contrasena')}*</p>
          <InputCustom
            type={passwordType}
            placeholder={`${t('contrasena')}`}
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            icon={handleIconType}
            className="px-0.75 login-fields"
            required
            error={password === '' && t('camporequerido', { ns: 'backoffice' })}
          />
          {passwordError && <span className="text-danger fs-6">{t('camporequerido', { ns: 'backoffice' })}</span>}
        </div>
      </Row>
      <Row className="container-input pt-3 pb-4">
        <div className={`col-md-6 text-center px-0 ${fromCarro && 'mx-auto'}`}>
          <Link to={`/${assignedLibrary}/recuperar-contrasena`} className="d-flex justify-content-center align-items-center">
            <p className="mt-1 blue fs-6 button-text">{t('olvidadoContrasena')}</p>
          </Link>
          <Button type="submit" variant="primary" extraClass="px-3 width-btn-login" loading={loading}>
            {t('iniciarSesion')}
          </Button>
        </div>
        {!fromCarro && (
          <div className="col-md-6 text-center px-0 d-flex align-items-center flex-column">
            <p className="mt-1 fs-6 button-text">{t('noRegistrado')}</p>
            <Link to={`/${assignedLibrary}/registro`} className="button-register width-btn-login ">
              <Button variant="secondary" extraClass="px-3" >
                {t('registrate')}
              </Button>
            </Link>
          </div>
        )}
      </Row>
    </Form>
  );
};

export default LoginComp;